/**
 * Route middleware that enforces one or more permissions from page meta.
 *
 * Usage in a page:
 *   definePageMeta({ middleware: ['auth', 'permission'], permission: 'user.read' })
 *   definePageMeta({ middleware: ['auth', 'permission'], permission: ['role.read', 'role.update'] })
 */
export default defineNuxtRouteMiddleware((to) => {
  const needed = to.meta.permission as string | string[] | undefined
  if (!needed) return

  const keys = Array.isArray(needed) ? needed : [needed]
  const { can } = usePermissions()
  if (!can(...keys)) {
    return abortNavigation(createError({
      statusCode: 403,
      statusMessage: `Akses ditolak: butuh permission "${keys.join(', ')}"`,
    }))
  }
})
